// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useFormik } from "formik";
// COMPONENTS
import Select from 'react-select';
import { Divider } from '@material-ui/core'
import { Link, useParams } from 'react-router-dom';
import { FilePond, registerPlugin } from "react-filepond";
import BlockUi from 'react-block-ui';
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { Modal, Row, Col, Form } from "react-bootstrap";
import Button from '../../../../components/Button';
import MaskedInput from 'react-maskedinput';
// CUSTOM COMPONENTS
import * as alert from '../../../../../redux/alertSnackBarRedux';
import SelectBlock from '../../../../components/SelectBlock';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import PLMDataHeaderValidator from '../../../../../helpers/validators/PLMDataHeaderValidator';
import PLMDataLineItemValidator from '../../../../../helpers/validators/PLMDataLineItemValidator';
import * as plmChainOfCustodyService from '../../../../../services/form/plmChainOfCustodyService';
import * as jobFormService from '../../../../../services/service/jobFormService';
import * as plmDataSheetService from '../../../../../services/form/plmDataSheetService';
import * as helper from "../../../../../helpers/helper";
//STYLES AND ASSETS

const initialState = {
    id: 0,
    inspectorId: 0,
    projectLocationId: null,
    surveyDate: new Date(),
    client: '',
    projectNumber: '',
    inspector: '',
    plmDataSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    sampleNumber: '',
    haNumber: '',
    description: '',
    location: '',
    quantity: '',
    dateTime: '',
    findingComparison: '',
    findingPercentage: '',
    findingType: ''
}

const haNumberInformationModel = {
    jobFormId: 0,
    plmDataSheetLineItemId: 0,
    haNumber: '',
    quantity: '',
    description: ''
}

const findingComparisonOptions = [{ label: 'None Detected', value: 'None Detected' }, { label: '<', value: '<' }]

const findingTypeOptions = [{ label: 'Chrysotile', value: 'Chrysotile' }, { label: 'Amosite', value: 'Amosite' }
    , { label: 'Crocidolite', value: 'Crocidolite' }, { label: 'Tremolite', value: 'Tremolite' }, { label: 'Other-Type', value: 'Other-Type' }]

const PLMDataSheetForm = (props) => {
    const iframeRef = useRef();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const { jobFormId, edit } = useParams();
    const [loading, setLoading] = useState(false);
    const [plmDataSheet, setHAPLMDataSheet] = useState(initialState);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [locationOptions, setLocationOptions] = useState([]);
    const [switchMode, setSwitchMode] = useState(false);
    const [refreshPage, setRefreshPage] = useState(false);
    const [selectedHANumber, setSelectedHANumber] = useState('');
    const [haNumberList, setHANumberList] = useState([]);
    const [doesHANumberExist, setDoesHANumberExist] = useState(false);
    const [selectedLineItem, setSelectedLineItem] = useState({ ...lineItemInitialState });
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedComparison, setSelectedComparison] = useState(null)
    const [selectedType, setSelectedType] = useState(null)
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isCOCSubmitted, setIsCOCSubmitted] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        plmChainOfCustodyId: 0,
        plmChainOfCustodyJobFormId: 0,
        name: "HA PLM Data Sheet",
        actualAssignedDate: new Date(),
        submittedById: 0,
        inspector: null,
        jobId: 0,
    });

    useEffect(() => {
        if (jobFormId) {
            if (edit == 'false') {
                setSwitchMode(true)
                getReport(jobFormId)
            }
            else {
                fetchJobLocations().then(res => {
                    fetchHAPLMDataSheet(res);
                });
                fetchHANumberList(jobFormId);
            }
        }
    }, [refreshPage])

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const fetchHANumberList = (jobFormId) => {
        plmDataSheetService.getHANumberList(jobFormId).then(res => {
            setHANumberList(res);
        })
    }

    const fetchHANumberById = (haNumber, jobFormId) => {

        plmDataSheetService.getHANumberById(haNumber, jobFormId).then(res => {
            setDoesHANumberExist(res ? true : false)
            formik_lineItem.setFieldValue('description', res.description ?? '');
            formik_lineItem.setFieldValue('quantity', res.quantity ?? '')
        })
    }

    const fetchHAPLMDataSheet = (projectLocations) => {
        setLoading(true);
        plmDataSheetService.getPLMDataSheetById(jobFormId).then(res => {
            if (res.plmDataSheet && res.plmDataSheet.projectLocationId) {
                setSelectedLocation(projectLocations.find(x => x.value == res.plmDataSheet.projectLocationId));
            }
            setIsReadOnly(res.submittedById !== 0);
            setJobForm(res);
            res.plmDataSheet && setHAPLMDataSheet(res.plmDataSheet);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const getReport = (id) => {
        if (id) {
            plmDataSheetService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const editLineItem = (id) => {
        setProcessing();
        setIsEdit(true);
        setIsModalOpen(true);
        let temp = [...plmDataSheet.plmDataSheetLineItems];
        let lineItemToEdit = { ...temp.find(x => x.id == id) };
        setSelectedLineItem(lineItemToEdit);
        if (lineItemToEdit) {
            setDoesHANumberExist(lineItemToEdit.haNumber ? true : false);
            setSelectedComparison(lineItemToEdit.findingComparison);
            setSelectedHANumber(lineItemToEdit.haNumber)
            setSelectedType(lineItemToEdit.findingType)
        }

    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {(!auth.isAdmin ? !isReadOnly : true) &&
                                <>
                                    <button
                                        type="button"
                                        href="#"
                                        className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => editLineItem(plmDataSheet.plmDataSheetLineItems[dataIndex].id)}
                                    >
                                        Edit
                                    </button>
                                    &nbsp;
                                    <button
                                        type="button"
                                        href="#"
                                        className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5"
                                        onClick={() => showConfirmModal({
                                            title: "Delete Line Item",
                                            text: "Are you sure you want to delete this line item?",
                                            rightBtnText: "Confirm",
                                            btnAction: () => removeLineItem(plmDataSheet.plmDataSheetLineItems[dataIndex].id)
                                        })}
                                    >
                                        Delete
                                    </button>
                                </>
                            }
                        </>
                    );
                }
            },

        },
        {
            name: "sampleNumber",
            label: "Sample #",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "haNumber",
            label: "HA #",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {plmDataSheet.plmDataSheetLineItems[dataIndex].haNumber ?? '-'}
                        </>
                    );
                }
            }
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {plmDataSheet.plmDataSheetLineItems[dataIndex].description ?? '-'}
                        </>
                    );
                }
            }
        },
        {
            name: "location",
            label: "Location",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {plmDataSheet.plmDataSheetLineItems[dataIndex].location ?? '-'}
                        </>
                    );
                }
            }
        },
        {
            name: "quantity",
            label: "Approximate Quantity",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "findingComparison",
            label: "Finding Comparison",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true
            }
        },
        {
            name: "findingPercentage",
            label: "Finding Percentage",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "findingType",
            label: "Finding Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        }
    ];

    const removeLineItem = (id) => {
        setProcessing();
        plmDataSheetService.deleteLineItem(id).then(res => {
            let temp = [...plmDataSheet.plmDataSheetLineItems];
            temp.splice(temp.findIndex(x => x.id === id), 1);
            setHAPLMDataSheet({ ...plmDataSheet, plmDataSheetLineItems: temp });
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const handleModalClose = () => {
        setRefreshPage(!refreshPage);
        setIsModalOpen(false);
        formik_lineItem.resetForm();
        setSelectedComparison(null);
        setSelectedHANumber(null)
        setSelectedType(null);
        setDoesHANumberExist(false);
        setIsEdit(false);
        setSelectedLineItem({ ...lineItemInitialState })

    }

    const handleHANumberUpdate = () => {
        if (doesHANumberExist) {
            plmDataSheetService.updateHANumber({
                ...haNumberInformationModel, jobFormId: jobFormId, haNumber: formik_lineItem.values.haNumber,
                quantity: formik_lineItem.values.quantity, description: formik_lineItem.values.description, plmDataSheetLineItemId: formik_lineItem.values.id
            }).then(res => {
            })
        }
    }

    const handleCreateCOC = () => {
        setProcessing();
        saveForm(formik.values).then(res => {
            plmChainOfCustodyService.generatePLMChainOfCustody(plmDataSheet.id).then(res => {
                showAlert({ message: "Success! PLM Chain Of Custody has been generated.", variant: 'success' });
                setJobForm({ ...jobForm, plmChainOfCustodyId: res.id, plmChainOfCustodyJobFormId: res.jobFormId });
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' });
            })
        }).catch(ex => { }).finally(() => {
            hideConfirmModal();
        })
    }

    const discardCOC = () => {
        setProcessing();
        plmChainOfCustodyService.discardCOC(jobForm.plmChainOfCustodyId).then(res => {
            showAlert({ message: "Success! Chain Of Custody form has been discarded.", variant: 'success' });
            setJobForm({ ...jobForm, plmChainOfCustodyId: null })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: plmDataSheet,
        validationSchema: PLMDataHeaderValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setLoading(false);
                setSubmitting(false);
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: selectedLineItem,
        validationSchema: PLMDataLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            handleHANumberUpdate();
            plmDataSheetService.saveLineItem({ ...values, plmDataSheetId: plmDataSheet.id, dateTime: new Date().toJSON() }).then(res => {
                                               
                // let temp = [...plmDataSheet.plmDataSheetLineItems];
                // if (isEdit) {
                //     temp[temp.findIndex(x => x.id == values.id)] = { ...values, id: res.id };
                // } else {
                //     temp.push({ ...values, id: res.id });
                // }
                // setHAPLMDataSheet({ ...plmDataSheet, plmDataSheetLineItems: temp });
                showAlert({ message: res.message, variant: 'success' });
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            }).finally(() => {
                setLoading(false);
                setSubmitting(false);
                handleModalClose();
            })
        }
    });

    const saveForm = (values) => {
        return plmDataSheetService.save(values).then(res => {
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const submitForm = () => {
        formik.validateForm().then(res => {
            if (Object.keys(res).length > 0) {
                let err = "";
                for (const property in res) {
                    err += res[property] + ". ";
                }

                showAlert({ message: err + " Please save before submitting the form", variant: 'error' });
                return;
            }

            saveForm(formik.values).then(res => {
                jobFormService.submitForm(jobForm.id).then(res => {
                    showAlert({ message: res.message, variant: 'success' });
                    history.push("/services/manage-job/forms/" + jobForm.jobId);
                }).catch(ex => {
                    showAlert({ message: ex.message, variant: 'error' })
                })
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        })
    }

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    <div className="card card-custom card-stretch">
                        <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                            <form className="card card-custom" onSubmit={formik_lineItem.handleSubmit}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Add Asbestos Survey Data Log</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="form">
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Sample #
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Sample Number"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="sampleNumber"
                                                    {...formik_lineItem.getFieldProps("sampleNumber")}
                                                />
                                                {formik_lineItem.touched.sampleNumber && formik_lineItem.errors.sampleNumber ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.sampleNumber}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                HA #
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                {/* <div className="col-lg-9 col-xl-9">
                                                <input
                                                    type="text"
                                                    placeholder="Enter HA Number"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="haNumber"
                                                    {...formik_lineItem.getFieldProps("haNumber")}
                                                />
                                                {formik_lineItem.errors.haNumber ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.haNumber}
                                                    </div>
                                                ) : null}
                                            </div> */}
                                                <SelectBlock
                                                    isClearable
                                                    creatableSelect
                                                    value={helper.setToOptionModel(selectedHANumber)}
                                                    options={haNumberList.map(x => helper.setToOptionModel(x.haNumber, x.haNumber))}
                                                    onChange={selectedOption => {
                                                        selectedOption = selectedOption === null ? [] : selectedOption;
                                                        setSelectedHANumber(selectedOption.value);
                                                        fetchHANumberById(selectedOption.value, jobFormId);
                                                        formik_lineItem.setFieldValue("haNumber", selectedOption.value);
                                                    }}
                                                    className={`${helper.getInputClasses(formik_lineItem, "haNumber")}`}
                                                    name="haNumber"
                                                    placeholder="HANumber"
                                                />
                                                {formik_lineItem.errors.haNumber ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.haNumber}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Description
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <Form.Control as="textarea" rows="5"
                                                    placeholder="Enter Description"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="description"
                                                    value={formik_lineItem.values.description}
                                                    onChange={(e) => { formik_lineItem.setFieldValue("description", e.target.value) }}
                                                // {...formik_lineItem.getFieldProps("description")}
                                                />
                                                {formik_lineItem.errors.description ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.description}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Approx. Quantity
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Quantity"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="quantity"
                                                    value={formik_lineItem.values.quantity}
                                                    onChange={(e) => { formik_lineItem.setFieldValue("quantity", e.target.value) }}
                                                // {...formik_lineItem.getFieldProps("quantity")}
                                                />
                                                {formik_lineItem.errors.quantity ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.quantity}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Location
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <input
                                                    type="text"
                                                    placeholder="Enter Location"
                                                    className={`form-control form-control-lg form-control-solid`}
                                                    name="location"
                                                    {...formik_lineItem.getFieldProps("location")}
                                                />
                                                {formik_lineItem.errors.location ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.location}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Findings Comparison
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <Select
                                                    isClearable
                                                    value={helper.setToOptionModel(selectedComparison)}
                                                    options={findingComparisonOptions}
                                                    onChange={selectedOption => {
                                                        selectedOption = selectedOption === null ? [] : selectedOption;
                                                        setSelectedComparison(selectedOption.value);
                                                        formik_lineItem.setFieldValue("findingComparison", selectedOption.value);
                                                    }}
                                                    className={`${helper.getInputClasses(formik_lineItem, "findingComparison")}`}
                                                    name="findingComparison"
                                                    placeholder="Select Finding Comparison"
                                                />
                                                {formik_lineItem.errors.findingComparison ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.findingComparison}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Findings Percentage
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                {/* <input
                                        type="text"
                                        placeholder="Enter Findings Percentage"
                                        className={`form-control form-control-lg form-control-solid`}
                                        name="findingPercentage"
                                        {...formik_lineItem.getFieldProps("findingPercentage")}
                                    /> */}
                                                <MaskedInput
                                                    className="form-control form-control-lg form-control-solid"
                                                    mask="11.11%"
                                                    placeholder="Enter Findings Percentage"
                                                    {...formik_lineItem.getFieldProps("findingPercentage")}
                                                />
                                                {formik_lineItem.errors.findingPercentage ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.findingPercentage}
                                                    </div>
                                                ) : null}

                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                Findings Type
                                            </label>
                                            <div className="col-lg-9 col-xl-9">
                                                <SelectBlock
                                                    isClearable
                                                    creatableSelect
                                                    value={helper.setToOptionModel(selectedType)}
                                                    options={findingTypeOptions}
                                                    onChange={selectedOption => {
                                                        selectedOption = selectedOption === null ? [] : selectedOption;
                                                        setSelectedType(selectedOption.value);
                                                        formik_lineItem.setFieldValue("findingType", selectedOption.value);
                                                    }}
                                                    className={`${helper.getInputClasses(formik_lineItem, "findingType")}`}
                                                    name="findingType"
                                                    placeholder="Select Finding Type"
                                                />
                                                {formik_lineItem.errors.findingType ? (
                                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                                        {formik_lineItem.errors.findingType}
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleModalClose}>
                                        Close
                                    </Button>
                                    {<>
                                        <button
                                            type="button"
                                            className="btn btn-danger mr-2"
                                            onClick={() => handleModalClose()}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success mr-2"
                                            disabled={
                                                formik_lineItem.isSubmitting || (formik_lineItem.touched && !formik_lineItem.isValid)
                                            }
                                        >
                                            {isEdit ? 'Save' : 'Add'}
                                            {formik_lineItem.isSubmitting}
                                        </button>
                                    </>

                                    }
                                </Modal.Footer>
                            </form>
                        </Modal>
                        {loading && <ModalProgressBar />}
                        <div className="card-header py-3">
                            <div className="card-title align-items-start flex-column">
                                <h3 className="card-label font-weight-bolder text-dark">
                                    HA PLM Data Sheet - ({moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")})
                                </h3>
                                <span className="text-muted font-weight-bold fz-xs mt-1">
                                    Please fill the form below
                                </span>
                            </div>
                            <div className="card-toolbar">
                                {
                                    <>
                                        <button
                                            className={`btn btn-info mr-2`}
                                            onClick={() => {
                                                setSwitchMode(true);
                                                getReport(jobForm ? jobForm.id : 0)
                                            }}
                                        >
                                            Print Form
                                        </button>

                                    </>
                                }
                            </div>
                        </div>
                        <div className="form">
                            <form className="card card-custom" onSubmit={formik.handleSubmit}>
                                <fieldset disabled={!auth.isAdmin && isReadOnly}>
                                    <div className="card-body">
                                        <Row>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Date
                                                    </label>
                                                    <div className="col-xl-6">
                                                        <input
                                                            readOnly
                                                            type="text"
                                                            placeholder="Survey Date"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="surveyDate"
                                                            value={moment(plmDataSheet.surveyDate).format("MM/DD/YYYY")}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        AES Project#
                                                    </label>
                                                    <div className="col-xl-6">
                                                        <input
                                                            readOnly
                                                            type="text"
                                                            placeholder="21-0003-01"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="name"
                                                            value={jobForm.projectNumber}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Client
                                                    </label>
                                                    <div className="col-xl-6">
                                                        <input
                                                            readOnly
                                                            type="text"
                                                            placeholder="Primtek LLC"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="client"
                                                            value={jobForm.client}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Inspector
                                                    </label>
                                                    <div className="col-xl-6">
                                                        <input
                                                            type="text"
                                                            placeholder="Inspector"
                                                            className={`form-control form-control-lg form-control-solid`}
                                                            name="inspector"
                                                            value={jobForm.inspector}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="form-group row">
                                                    <label className="col-form-label col-xl-2 col-lg-2 col-form-label fz-mdsm fw-600">
                                                        Project Location
                                                    </label>
                                                    <div className="col-xl-10">
                                                        <Select
                                                            value={selectedLocation}
                                                            options={locationOptions}
                                                            onChange={selectedOption => {
                                                                selectedOption = selectedOption === null ? [] : selectedOption;
                                                                setSelectedLocation(selectedOption);
                                                                formik.setFieldValue("projectLocationId", selectedOption.value);
                                                            }}
                                                            className={`${helper.getInputClasses(formik, "projectLocationId")}`}
                                                            name="projectTypeId"
                                                            placeholder="Select Project Location"
                                                        />
                                                        {formik.touched.projectLocationId && formik.errors.projectLocationId ? (
                                                            <div className="invalid-feedback">
                                                                {formik.errors.projectLocationId}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="d-flex justify-content-between">
                                            <div className="d-flex">
                                                <h5 className="mt-lg-10 mb-6 fz-md fw-700 c-primary">Hazardous Material Survey Sheet-Asbestos Line Items</h5>
                                            </div>
                                            {
                                                !isReadOnly &&
                                                <div className="d-flex align-items-center">
                                                    <button
                                                        type="button"
                                                        onClick={() => setIsModalOpen(true)}
                                                        className="btn btn-info mr-2 fit-content"

                                                    >
                                                        Add Line Items
                                                    </button>

                                                </div>
                                            }
                                        </div>
                                        <Divider />
                                        <MUIDataTable
                                            data={plmDataSheet.plmDataSheetLineItems}
                                            columns={columns}
                                            options={{
                                                selectableRows: 'none',
                                            }}
                                        />

                                        {!auth.isAdmin ?
                                            !isReadOnly &&
                                            <div className={'flex justify-content-end mt-20'}>
                                                {
                                                    jobForm.plmChainOfCustodyId ?
                                                        <>
                                                            <Button
                                                                text="Discard COC"
                                                                onClick={() =>
                                                                    showConfirmModal({
                                                                        title: "Discard Chain Of Custody",
                                                                        text: "Are you sure you want to discard the current Chain Of Custody for this datasheet?",
                                                                        rightBtnText: "Confirm",
                                                                        btnAction: () => discardCOC()
                                                                    })
                                                                }
                                                                className="danger--bg"
                                                            />
                                                            &nbsp;
                                                            <Button
                                                                text="View COC"
                                                                to={"/forms/plm-coc/" + jobForm.plmChainOfCustodyJobFormId + '/true'}
                                                                className="info--bg"
                                                            />
                                                        </>
                                                        :
                                                        <Button
                                                            text="Generate COC"
                                                            onClick={() =>
                                                                showConfirmModal({
                                                                    title: "Generate Chain Of Custody",
                                                                    text: "Are you sure you want to generate a Chain Of Custody for this datasheet?",
                                                                    rightBtnText: "Confirm",
                                                                    btnAction: () => handleCreateCOC()
                                                                })
                                                            }
                                                            className="info--bg"
                                                        />
                                                }
                                                &nbsp;
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary mr-2 fit-content"
                                                    disabled={
                                                        formik.isSubmitting || (formik.touched && !formik.isValid)
                                                    }
                                                >
                                                    Save Changes
                                                    {formik.isSubmitting}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className={`btn btn-success mr-2`}
                                                    disabled={
                                                        formik.isSubmitting || (formik.touched && !formik.isValid)
                                                    }
                                                    onClick={() => submitForm()}
                                                >
                                                    Submit Form
                                                    {formik.isSubmitting}
                                                </button>
                                            </div>
                                            :
                                            <div className={'flex justify-content-end mt-20'}>
                                                {
                                                    jobForm.plmChainOfCustodyId ?
                                                        <>
                                                            <Button
                                                                text="Discard COC"
                                                                onClick={() =>
                                                                    showConfirmModal({
                                                                        title: "Discard Chain Of Custody",
                                                                        text: "Are you sure you want to discard the current Chain Of Custody for this datasheet?",
                                                                        rightBtnText: "Confirm",
                                                                        btnAction: () => discardCOC()
                                                                    })
                                                                }
                                                                className="danger--bg"
                                                            />
                                                            &nbsp;
                                                            <Button
                                                                text="View COC"
                                                                to={"/forms/plm-coc/" + jobForm.plmChainOfCustodyJobFormId + '/true'}
                                                                className="info--bg"
                                                            />
                                                        </>
                                                        :
                                                        <Button
                                                            text="Generate COC"
                                                            onClick={() =>
                                                                showConfirmModal({
                                                                    title: "Generate Chain Of Custody",
                                                                    text: "Are you sure you want to generate a Chain Of Custody for this datasheet?",
                                                                    rightBtnText: "Confirm",
                                                                    btnAction: () => handleCreateCOC()
                                                                })
                                                            }
                                                            className="info--bg"
                                                        />
                                                }
                                                &nbsp;
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary mr-2 fit-content"
                                                    disabled={
                                                        formik.isSubmitting || (formik.touched && !formik.isValid)
                                                    }
                                                >
                                                    Save Changes
                                                    {formik.isSubmitting}
                                                </button>
                                                {
                                                    !isReadOnly &&
                                                    <button
                                                        type="submit"
                                                        className={`btn btn-success mr-2`}
                                                        disabled={
                                                            formik.isSubmitting || (formik.touched && !formik.isValid)
                                                        }
                                                        onClick={() => submitForm()}
                                                    >
                                                        Submit Form
                                                        {formik.isSubmitting}
                                                    </button>

                                                }

                                            </div>
                                        }
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
            }
        </>

    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(PLMDataSheetForm);